import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MusicPage from "../../components/user/Music";
import StreamChart from "../../components/admin/StreamChart";
import { musicService } from "../../services";
import Spinner from "../../components/UI/Spinner";
import ErrorModal from "../../components/UI/Error";

const MusicViewPage = () => {
  const { id } = useParams();
  const [music, setMusic] = useState(null);
  const [streamChartData, setStreamChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchMusic = async () => {
      try {
        setError(false);
        let musicResponse = await musicService.singleMusic(id);
        musicResponse = {
          ...musicResponse,
          releaseDate: musicResponse.releaseDate.split("T")[0],
        };
        const { appleMusic, spotify, amazonMusic } = musicResponse.streams;
        const streamChartData = [
          { key: "apm", platform: "Apple Music", streams: appleMusic.stream },
          { key: "sfy", platform: "Spotify", streams: spotify.stream },
          { key: "azm", platform: "Amazon Music", streams: amazonMusic.stream },
          // { key: "YTM", platform: "Youtube Music", streams: youtubeMusic.stream },
          //{ key: "BMP", platform: "Boomplay", streams: boomplay.stream },
        ];
        setMusic(musicResponse);
        setStreamChartData(streamChartData);
      } catch (error) {
        setError(true);
        console.error("Error fetching music details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMusic();
  }, [id]);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );
  if (error || !music)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={"Error Fetching Music"}
        message={
          "There is error while trying to fetch the music details. Please check your internet contivities and refresh this page to try again"
        }
      />
    );

  return (
    <MusicPage music={music} editMusic={`/user/my-music/edit`}>
      <StreamChart streamChartData={streamChartData} />
    </MusicPage>
  );
};

export default MusicViewPage;
